import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Loading from "../../components/Loading";
import {FaUser, FaUserEdit, FaTrash, FaFileContract} from 'react-icons/fa';
import Paper from '@mui/material/Paper';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Button, CardActions, Snackbar } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import MuiAlert from '@mui/material/Alert'

import { getEmailLogin, getUserId } from '../../services/auth';
import { useTheme } from '@mui/material/styles';
import HeaderBody from '../../components/HeaderBody';
import GroupAdd from '@mui/icons-material/GroupAdd';
import PersonAdd from '@mui/icons-material/PersonAdd';
import nest from '../../services/nest';
import ModalNewUser from './ModalNewUser';
import ModalDeleteUser from './ModalDeleteUser';
import ModalEditUser from './ModalEditUser';
import ModalEditarPerfilMaster from './ModalEditarPerfilMaster';
import ModalEditarSenha from './ModalEditarSenha';
import ModalEditarContratos from './ModalEditarContratos';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})


function Usuarios({setShowFaturas}) {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [mostrar, setmotrar] = useState(false);
    const [text, setText] = useState({});
    const [idUsuarioDependente, setIdUsuarioDependente] = useState(0)
    const [modalExcluirUsuarioVisible, setModalExcluirUsuarioVisible] = useState(false);
    const [usuarioParaExcluir, setUsuarioParaExcluir] = useState({ id: 0, nome: '' });
    const [alerta, setAlerta] = useState({
        status: false,
        msg: ''
    })
    const [modalEditarContratosVisible, setModalEditarContratosVisible] = useState(false);
    const [arrayIdsContratos, setArrayIdsContratos] = useState([]);
    const [modalEditarUsuarioVisible, setModalEditarUsuarioVisible] = useState(false);
    const [modalVisibleSenha, setModalVisibleSenha] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [list, setList] = useState([]);
    useEffect(() => {
        getClienteUsuarioInformation();
        loadOutrosUsuariosAbaixo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
     const getClienteUsuarioInformation = async () => {
        setLoading(true)
        let email = await getEmailLogin();
        nest.get(`/cliente/cliente-usuarios/buscaUsuario`,{
            params: {
                email: email
            }
        }).then(function (response) {
            setLoading(false)
            setText(response.data)
        }).catch(function(error){
            console.log(error)
        });
    }
    const loadOutrosUsuariosAbaixo = async () => {
       let clienteUsuarioId = await getUserId();
        nest.get(`/cliente/cliente-usuarios/buscaUsuarioDependente`,{
            params: {
                clienteUsuarioId
            }
        }).then(async function (response) {
            const usuarios = response.data;
            
            const usuariosComContratos = [];
            for(const usuario of usuarios) {
                const contratos = usuario.acessos?.map(acesso => acesso.contrato_id);
                if(usuario) {
                    usuariosComContratos.push({
                        ...usuario,
                        contratos: contratos || []
                    });
                }
            }
            setList(usuariosComContratos);

            setLoading(false);

        }).catch(function(error){
            console.log(error)
        });
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setAlerta({
            status: false,
            msg: ''
        })
    }

    const excluirUser = async () => {
        setLoading(true)
        let clienteUsuarioId = getUserId();
        nest.put('/cliente/cliente-usuarios/excluirUsuario',
            null,
            {
            params: {
                clienteUsuarioId: usuarioParaExcluir.id,
                conta_master_id: clienteUsuarioId
            }
        }).then(function (response) {
            setLoading(false)
            loadOutrosUsuariosAbaixo()
            setAlerta({
                status: true,
                msg: 'Excluído com sucesso!',
                type: 'success'
            })
        }).catch(function(error){
            console.log(error)
            setAlerta({
                status: true,
                msg: 'Ocorreu um erro!',
                type: 'error'
            })
            setLoading(false)
        });
    }
    const [height, setWidth] = useState(0);
    useEffect(() => {
        const element = document.getElementById('home');
        if (element) {
          setWidth(element.getBoundingClientRect().height - 260); // or height
        }
    }, []);
    const handleOpenModalSenha = () => {
        setModalVisible(false);
        setModalVisibleSenha(true);  
      };
    const renderCards = (element, idx) => {
        const {email, id, nome, clienteUsuarioCargoRelation, clienteUsuarioSetor, contratos} = element;
        const { nome: cargoNome} = clienteUsuarioCargoRelation;
        const {nome: setorNome} = clienteUsuarioSetor;
        return (
            <div key={idx} className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" style={{marginBottom: 20, marginTop: 20}}>
                <Paper elevation={12}>
                    <CardContent>
                        <Stack direction="row" spacing={2}>
                            <Avatar sx={{ backgroundColor: 'var(--main-bg-color)', width: 50, height: 50 }} >
                                <FaUser color={"var(--main-white-color)"} size={30} />
                            </Avatar>
                            <Stack direction="column" spacing={0}>
                                <Typography gutterBottom variant="body2" component="div">
                                    Nome: {nome}
                                </Typography>
                                <Typography gutterBottom variant="body2" component="div">
                                    E-mail: {email}
                                </Typography>
                                <Typography gutterBottom variant="body2" component="div">
                                    Cargo: {cargoNome}
                                </Typography>
                                <Typography gutterBottom variant="body2" component="div">
                                    Setor: {setorNome}  
                                </Typography>
                                <Typography gutterBottom variant="body2" component="div">
                                    Contratos: {contratos.join(", ") || "Nenhum contrato"}
                                </Typography>
                            </Stack>
                        </Stack>
                    </CardContent>
                    <CardActions style={{justifyContent: 'space-around', paddingBottom: 16}}>
                        <Button 
                            variant="contained" 
                            style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                            size="small" 
                            startIcon={<FaUserEdit />}
                            onClick={() => {
                                setIdUsuarioDependente(id)
                                setModalEditarUsuarioVisible(true)
                            }}
                            >
                            Editar
                        </Button>
                        <Button 
                            variant="contained" 
                            style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                            size="small" 
                            startIcon={<FaFileContract />}
                            onClick={() => {
                                setIdUsuarioDependente(id)
                                setArrayIdsContratos(contratos)
                                setModalEditarContratosVisible(true)
                            }}
                            >
                            Editar Contratos
                        </Button>
                        <Button 
                            variant="contained" 
                            style={{backgroundColor: '#E34234', borderRadius: 25}} 
                            size="small" 
                            startIcon={<FaTrash />}
                            onClick={() => {
                                setUsuarioParaExcluir({ id: id, nome: nome })
                                setModalExcluirUsuarioVisible(true)
                            }}
                            >
                            Excluir
                        </Button>
                    </CardActions>
                </Paper>
            </div>
        );
    }
    return (
        <Card style={{margin: 20}} className={theme.palette.mode === "dark" ? "bg-dark text-white" : null}>
            <Loading open={loading} />
            <Card.Header>
                <HeaderBody title={"Usuários"} setShow={setShowFaturas} >
                    <div style={{
                        backgroundColor: "var(--main-bg-color)", 
                        padding: 6, 
                        width: 35, 
                        height: 35, 
                        borderRadius: 52, 
                        display: "flex", 
                        justifyContent: 'center', 
                        alignItems: 'center'
                    }}
                    >
                        <GroupAdd sx={{color: "var(--main-white-color)"}} />
                    </div>
                </HeaderBody>
            </Card.Header>
            <Card.Body className='row' style={{paddingTop: 0, paddingBottom: 0}}>
                <div style={{overflow: "auto", height: height}}>
                    <div className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" style={{marginBottom: 20, marginTop: 20}}>
                        <Paper elevation={12} style={{backgroundColor: '#e3e3e3'}}>
                            <CardContent>
                                <Stack direction="row" spacing={2}>
                                    <Avatar sx={{ backgroundColor: 'var(--main-bg-color)', width: 50, height: 50 }} >
                                        <FaUser color={"var(--main-white-color)"} size={30} />
                                    </Avatar>
                                    <Stack direction="column" spacing={0}>
                                        <Typography gutterBottom variant="body2" component="div">
                                            Nome: {text.nome}
                                        </Typography>
                                        <Typography gutterBottom variant="body2" component="div">
                                            E-mail: {text.email}
                                        </Typography>
                                        <Typography gutterBottom variant="body2" component="div">
                                            Cargo: {text.clienteUsuarioCargoRelation?.nome}
                                        </Typography>
                                        <Typography gutterBottom variant="body2" component="div">
                                            Setor: {text.clienteUsuarioSetor?.nome}
                                        </Typography>
                                    </Stack>
                                </Stack>
                            </CardContent>
                            <CardActions style={{justifyContent: 'space-around', paddingBottom: 16}}>
                                <Button 
                                    variant="contained" 
                                    style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                                    size="small" 
                                    startIcon={<FaUserEdit />}
                                    onClick={() => {
                                        setModalVisible(true)
                                    }}
                                    >
                                    Editar Perfil
                                </Button>
                                {(text.cargo_id === 1) && (
                                    <Button 
                                        variant="contained" 
                                        style={{backgroundColor: 'var(--main-bg-color)', borderRadius: 25}} 
                                        size="small" 
                                        startIcon={<PersonAdd />}
                                        onClick={() => setmotrar(true)}
                                        >
                                        Criar dependentes
                                    </Button>
                                )}
                            </CardActions>
                        </Paper>
                    </div>
                    {list.map((elemeto, index) => (
                        renderCards(elemeto, index)
                    ))}
                </div>
            </Card.Body>
            <ModalNewUser 
                mostrar={mostrar} 
                handleClose={() => setmotrar(false)} 
                loadOutrosUsuariosAbaixo={loadOutrosUsuariosAbaixo} 
                setIdUsuarioDependente={setIdUsuarioDependente} 
                setAlerta={setAlerta}
                setModalEditarUsuarioVisible={setModalEditarContratosVisible}
            />
            <ModalDeleteUser
                mostrar={modalExcluirUsuarioVisible}
                handleClose={() => setModalExcluirUsuarioVisible(false)}
                excluirUser={excluirUser}
                usuarioNome={usuarioParaExcluir.nome}
            />
            <ModalEditUser 
                mostrar={modalEditarUsuarioVisible}
                handleClose={() => setModalEditarUsuarioVisible(false)}
                loadOutrosUsuariosAbaixo={loadOutrosUsuariosAbaixo} 
                setAlerta={setAlerta}
                idUsuarioDependente={idUsuarioDependente}
                list={list}
            />
            <ModalEditarPerfilMaster
                mostrar={modalVisible}
                handleClose={() => setModalVisible(false)}
                setAlerta={setAlerta}
                handleOpenModalSenha={handleOpenModalSenha}
                userMaster={text}
                loadOutrosUsuariosAbaixo={getClienteUsuarioInformation}
            />
            <ModalEditarSenha
                mostrar={modalVisibleSenha}
                handleClose={() => setModalVisibleSenha(false)}
                setAlerta={setAlerta}
            />
            <ModalEditarContratos
                modalEditarContratosVisible={modalEditarContratosVisible}
                setModalEditarContratosVisible={setModalEditarContratosVisible}
                idUsuarioDependente={idUsuarioDependente}
                loadOutrosUsuariosAbaixo={loadOutrosUsuariosAbaixo}
                arrayIdsContratos={arrayIdsContratos}
                setAlerta={setAlerta}
            />
            <Snackbar
                open={alerta.status}
                autoHideDuration={6000}
                onClose={handleClose}
                >
                <Alert
                    onClose={handleClose}
                    severity={alerta.type}
                    sx={{ width: '100%' }}
                >
                    {alerta.msg}
                </Alert>
            </Snackbar>
        </Card>
    );
}

export default Usuarios;